import { useEffect, useRef, useState } from 'react';
import { postToast } from 'features/common/utils/postFlash';

export const MUTATION_TIMEOUT_MS = 30_000;

/**
 * Returns a derived isLoading that automatically flips to false after MUTATION_TIMEOUT_MS,
 * firing an error toast so the user is not left with a permanently locked dialog on network hang.
 * The timer resets on every new loading cycle (isLoading false → true transition).
 */
export function useMutationTimeout(isLoading: boolean, errorMessage: string): boolean {
	const [timedOut, setTimedOut] = useState(false);
	const errorRef = useRef(errorMessage);
	errorRef.current = errorMessage;

	useEffect(() => {
		if (!isLoading) {
			setTimedOut(false);
			return;
		}
		const id = window.setTimeout(() => {
			setTimedOut(true);
			postToast('error', errorRef.current);
		}, MUTATION_TIMEOUT_MS);
		return () => window.clearTimeout(id);
	}, [isLoading]);

	return isLoading && !timedOut;
}
